import { useNavigate } from "react-router-dom";
import { useState } from "react";

const QuizBoardLandingHeroSection = () => {
  const navigate = useNavigate();

  const handleQuizButton = () => {
    const token = localStorage.getItem("access_token"); 
    if (token) {
      navigate("/quiz");
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <section className="position-relative py-5 d-flex align-items-center justify-content-center overflow-md-hidden bg-main">
      <div
        class="position-absolute animate-float main-floating-icon icon-top-left"
        style={{ top: "80px", left: "40px" }}
      >
        <div
          class="d-flex align-items-center justify-content-center bg-gradient-primary rounded shadow-glow"
          style={{ width: "64px", height: "64px" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-trophy text-white"
          >
            <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
            <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
            <path d="M4 22h16"></path>
            <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
            <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
            <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
          </svg>
        </div>
      </div>
      <div
        class="position-absolute animate-float main-floating-icon icon-top-right"
        style={{ top: "160px", right: "80px" }}
      >
        <div
          class="d-flex align-items-center justify-content-center bg-card rounded shadow-card"
          style={{ width: "48px", height: "48px" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-book-open text-accent"
          >
            <path d="M12 7v14"></path>
            <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
          </svg>
        </div>
      </div>
      <div
        class="position-absolute animate-float main-floating-icon icon-bottom-left"
        style={{ bottom: "160px", left: "80px", animationDelay: "1s" }}
      >
        <div
          class="d-flex align-items-center justify-content-center rounded"
          style={{
            width: "56px",
            height: "56px",
            background: "rgba(139, 92, 246, 0.2)",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-award text-secondary-custom"
          >
            <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
            <circle cx="12" cy="8" r="6"></circle>
          </svg>
        </div>
      </div>
      <div
        class="container text-center position-relative"
        style={{ zindex: "10" }}
      >
        <div class="animate-fade-in">
          <h1
            class="hero-title display-1 fw-bold mb-2 mt-3"
            style={{
              background:
                "linear-gradient(to right, rgb(248, 250, 252), rgb(59, 130, 246), rgb(139, 92, 246)) text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Master Coding Skills
          </h1>
          <h2 class="hero-subtitle display-4 fw-semibold mb-4 text-muted-custom">
            Excel in
            <span class="text-primary-custom font-code"> CSE </span>
            Interviews &amp; Competitions
          </h2>
        </div>
        <div class="animate-slide-up mb-5">
          <p
            class="lead text-muted-custom mx-auto"
            style={{ maxWidth: "600px" }}
          >
            Prepare for placements, practice coding problems, earn skill
            certificates, and compete in tournaments. Your complete platform for
            coding excellence.
          </p>
        </div>
        <div class="animate-scale-in d-flex flex-wrap justify-content-center gap-3 mb-5">
          <div class="d-flex align-items-center gap-2 bg-card px-3 py-2 rounded-pill border-custom shadow-card">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-target text-primary-custom"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <circle cx="12" cy="12" r="6"></circle>
              <circle cx="12" cy="12" r="2"></circle>
            </svg>
            <small class="fw-medium text-white">Placement Prep</small>
          </div>
          <div class="d-flex align-items-center gap-2 bg-card px-3 py-2 rounded-pill border-custom shadow-card">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-book-open text-accent"
            >
              <path d="M12 7v14"></path>
              <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
            </svg>
            <small class="fw-medium text-white">Practice Quiz</small>
          </div>
          <div class="d-flex align-items-center gap-2 bg-card px-3 py-2 rounded-pill  border-custom shadow-card">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-award text-secondary-custom"
            >
              <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
              <circle cx="12" cy="8" r="6"></circle>
            </svg>
            <small class="fw-medium text-white">Skill Certificates</small>
          </div>
          <div class="d-flex align-items-center gap-2 bg-card px-3 py-2 rounded-pill border-custom shadow-card">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-trophy text-primary-custom"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
              <path d="M4 22h16"></path>
              <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
              <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
            </svg>
            <small class="fw-medium text-white">Contests</small>
          </div>
        </div>
        <div class="animate-scale-in d-flex flex-column flex-sm-row gap-3 justify-content-center">
          <button class="btn btn-gradient-primary btn-lg px-4 py-3 glow-effect text-white mb-3" onClick={handleQuizButton}>
            Start Your Journey
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-arrow-right ms-2"
            >
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </button>
          <button class="btn btn-outline-custom btn-lg px-4 py-3 text-white mb-3" onClick={handleQuizButton}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-play me-2"
            >
              <polygon points="6 3 20 12 6 21 6 3"></polygon>
            </svg>
            Watch Demo
          </button>
        </div>
      </div>
    </section>

    </>
  )
};

export default QuizBoardLandingHeroSection;
